// extracted by mini-css-extract-plugin
module.exports = {"tr":"ExceptionWordsTable_tr__2Jkk-"};